/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SsoLoginWorkspacesQueryVariables = Types.Exact<{
  email: Types.Scalars["String"]["input"];
}>;

export type SsoLoginWorkspacesQuery = {
  readonly __typename: "Query";
  readonly ssoLoginWorkspaces: ReadonlyArray<{
    readonly __typename: "SsoLoginWorkspace";
    readonly orgId: c.OrgId;
    readonly displayName: string;
    readonly hasCustomAppIcon: boolean;
  }>;
};

export const SsoLoginWorkspacesDocument = /*#__PURE__*/ gql`
  query SsoLoginWorkspaces($email: String!) {
    ssoLoginWorkspaces(email: $email) {
      orgId
      displayName
      hasCustomAppIcon
    }
  }
`;

/**
 * __useSsoLoginWorkspacesQuery__
 *
 * To run a query within a React component, call `useSsoLoginWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoLoginWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoLoginWorkspacesQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSsoLoginWorkspacesQuery(
  baseOptions: Apollo.QueryHookOptions<
    SsoLoginWorkspacesQuery,
    SsoLoginWorkspacesQueryVariables
  > &
    (
      | { variables: SsoLoginWorkspacesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SsoLoginWorkspacesQuery,
    SsoLoginWorkspacesQueryVariables
  >(SsoLoginWorkspacesDocument, options);
}
export function useSsoLoginWorkspacesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SsoLoginWorkspacesQuery,
    SsoLoginWorkspacesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SsoLoginWorkspacesQuery,
    SsoLoginWorkspacesQueryVariables
  >(SsoLoginWorkspacesDocument, options);
}
export function useSsoLoginWorkspacesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SsoLoginWorkspacesQuery,
    SsoLoginWorkspacesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SsoLoginWorkspacesQuery,
    SsoLoginWorkspacesQueryVariables
  >(SsoLoginWorkspacesDocument, options);
}
export type SsoLoginWorkspacesQueryHookResult = ReturnType<
  typeof useSsoLoginWorkspacesQuery
>;
export type SsoLoginWorkspacesLazyQueryHookResult = ReturnType<
  typeof useSsoLoginWorkspacesLazyQuery
>;
export type SsoLoginWorkspacesSuspenseQueryHookResult = ReturnType<
  typeof useSsoLoginWorkspacesSuspenseQuery
>;
export type SsoLoginWorkspacesQueryResult = Apollo.QueryResult<
  SsoLoginWorkspacesQuery,
  SsoLoginWorkspacesQueryVariables
>;
